<template>
  <div style="margin: 0 24px 12px;">
    <el-form ref="formRef" label-width="auto" label-position="right">
      <el-form-item label="商品名称：">
        {{stockForm.commodityName}}
      </el-form-item>
      <el-form-item label="盘点库存：">
        <el-input v-model="takeNum" placeholder="请输入门店现有库存" />
      </el-form-item>
<!--      <el-form-item label="备注：">-->
<!--        <el-input type="textarea" :rows="4" v-model="breakageRemark" placeholder="请输入报损原因" style="width: 100%; flex: 1"/>-->
<!--      </el-form-item>-->
    </el-form>
    <div class="dialog-footer" style="text-align: center; margin-top: 16px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import {updateCommodityTakeNum} from "@/api/url";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      type: this.value.type,
      stockForm: this.value.stockForm,

      takeNum: this.value.stockForm.takeNum == -1?'':this.value.stockForm.takeNum,

    }
  },
  methods: {



    cancel() {
      this.$emit("close");
    },
    summit() {
      if(!this.takeNum && this.takeNum != '0') {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入数量',
          type: 'warning'
        });
        return false
      }
      let param = {}
      param['id'] = this.stockForm.id
      param['takeNum'] = this.takeNum
      // param['breakageRemark'] = this.breakageRemark
      postFormData(updateCommodityTakeNum, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },





  },
  mounted() {
  }
}
</script>

<style scoped>

</style>
